import { useState } from 'react'
import { KTSVG } from '../../../../../_dashboard/helpers'
import { useQueryRequest } from '../core/QueryRequestProvider'
import dataAxios from '../../../../modules/auth/core/dataAxios'

const API_URL = process.env.REACT_APP_API_URL || ''

const ReservationsListToolbar = () => {
  const { state } = useQueryRequest()
  const [exporting, setExporting] = useState(false)

  const handleExport = async () => {
    setExporting(true)
    try {
      const { page, size, ...filters } = state
      const response = await dataAxios.get(`${API_URL}/export`, {
        params: {
          dataType: 'reservations',
          exportAs: 'excel',
          ...filters,
        },
      })
      const url = response.data?.data?.url
      if (url) {
        const cleanUrl = url.replace(/^\.\//, '/')
        const baseUrl = API_URL.replace(/\/api\/?$/, '')
        window.open(`${baseUrl}${cleanUrl}`, '_blank')
      }
    } catch (error) {
      console.error('Export failed', error)
    } finally {
      setExporting(false)
    }
  }

  return (
    <div className='d-flex justify-content-end' data-kt-hotel-table-toolbar='base'>
      <button
        type='button'
        className='btn btn-light-primary me-3'
        onClick={handleExport}
        disabled={exporting}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        {exporting ? 'Export...' : 'Export'}
      </button>
    </div>
  )
}

export { ReservationsListToolbar }
